import styled from 'styled-components';
import BookingHeaderSVG from '../../assets/header/ic-booking.svg';

const BookingHeaderIcon = styled(BookingHeaderSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.3rem'};
  fill: ${props => props.color};
  margin: ${props => props.margin};
`;

export default BookingHeaderIcon;
